{
  "home": {
    "title": "Inicio",
    "welcome": "Bienvenido",
    "welcome_user": "Bienvenido, %{user}"
  }
}
